import { FilterdColumns } from '@oscar/table';
import { REQUEST_STATUS } from 'common/constants';
import React from 'react';
import './style.scss';

const { OptionGroup } = FilterdColumns;

function FilterStatusColumnTable(props: any) {
  return (
    <OptionGroup
      {...props}
      data={Object.values(REQUEST_STATUS).map(item => ({
        value: item.VALUE,
        label: item.TEXT,
      }))}
    />
  );
}

export default FilterStatusColumnTable;
